<template>
  <v-row no-gutters>
    <v-col
      cols="12"
      md="12"
      sm="12"
    >
      <v-text-field
        v-model="clase.cupo"
        :disabled="$store.state.app.onlyShow"
        :label="$t('lbl.cupo')"
        type="number"
        min="0"
        hide-details
        dense
        outlined
      ></v-text-field>
    </v-col>
    <v-col
      cols="12"
      md="2"
      sm="2"
    ></v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    // eslint-disable-next-line vue/require-default-prop
    clase: {
      type: Object,
    },
  },
}
</script>
